<template>
  <div class="navbar">
    <hamburger :is-active="sidebarOpened" class="hamburger-container" @toggleClick="toggleSideBar" />
    <div class="app-title">牲畜防疫检测系统</div>
    <div class="right-menu">
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <span>管理员</span>
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <el-dropdown-item>
            <span @click="handleLogout">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Hamburger from '@/components/Hamburger'

export default {
  components: {
    Hamburger
  },
  computed: {
    ...mapGetters([
      'sidebar'
    ]),
    sidebarOpened() {
      return this.sidebar && this.sidebar.opened
    }
  },
  methods: {
    toggleSideBar() {
      console.log('toggleSideBar called in Navbar, current state:', this.sidebar)
      this.$store.dispatch('app/toggleSideBar')
      console.log('After dispatch, sidebar state:', this.$store.state.app.sidebar)
    },
    handleLogout() {
      console.log('退出登录')
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);
  display: flex;
  align-items: center;
  
  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    padding: 0 15px;
    
    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }
  
  .app-title {
    margin-left: 20px;
    font-size: 18px;
    font-weight: bold;
    color: #303133;
  }
  
  .right-menu {
    margin-left: auto;
    margin-right: 30px;
    
    .avatar-container {
      .avatar-wrapper {
        display: flex;
        align-items: center;
        cursor: pointer;
        
        span {
          margin-right: 5px;
        }
      }
    }
  }
}
</style> 